import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/subprocessors/*.md"))

export const Route = createFileRoute("/_content/subprocessors/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Subprocessor List (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Subprocessor List from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/subprocessors/${loaderData.date}`,
      image: "https://entire.com/og/page/subprocessors.png",
      noindex: true,
    })
  },
  component: SubprocessorsVersionPage,
})

function SubprocessorsVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/subprocessors" version={version} versions={versions} />
}
